<template>
  <div class="detail-pages display-grid gap-10" v-if="pageContent">
    <div class="detail-pages-title px-20 px-lg-0 display-none display-lg-block" v-if="deviceType.isDesktop">
      <h1 class="typo-h1 mb-0">
        {{ pageTitle }}
      </h1>
    </div>
    <div class="detail-pages-content">
      <div class="content-wrapper px-20 px-md-30 px-lg-0">
        <div v-html="pageContent" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    async asyncData({ $axios }) {
      let pageContent = ''
      let pageTitle = ''

      try {
        const reponse = await $axios.get(`/content/${3}`)
        if (reponse?.data) {
          pageTitle = reponse.data.title
          pageContent = reponse.data.content

          const jsonString = JSON.stringify(pageContent)
            .replace(/http:\/\/airalo.com/g, 'https://www.airalo.com')
            .replace(/https:\/\/airalo.com/g, 'https://www.airalo.com')
            .replace(/http:\/\/www.airalo.com/g, 'https://www.airalo.com')

          pageContent = JSON.parse(jsonString)
        }
      } catch (error) {
        pageContent = null
      }

      return {
        pageTitle,
        pageContent,
      }
    },

    computed: {
      deviceType() {
        return this.$store.getters.get_device_types
      },
    },

    head() {
      return {
        title: this.$t('seo.terms.conditions.title'),

        meta: [
          {
            hid: 'description',
            name: 'description',
            content: this.$t('seo.terms.conditions.description'),
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content: this.$t('seo.terms.conditions.keywords'),
          },
          {
            property: 'og:title',
            content: this.$t('seo.terms.conditions.title'),
          },
          {
            property: 'og:description',
            content: this.$t('seo.terms.conditions.description'),
          },
        ],
      }
    },

    scrollToTop: true,
  }
</script>
